<div class="refund-detail-page-wrapper">
  <div class="header-wrapper">
    <div class="back-button" (click)="goBack()">
      <fa-icon [icon]='faArrowLeft'></fa-icon>
      <p>Volver</p>
    </div>
  </div>
  <div class="content-wrapper" *ngIf="loadedContent==true">
    <div class="title-wrapper">
      <span>{{orderInfo.id_invoicing}}</span>
    </div>
    <div class="detail-card">
      <div class="detail-card-header">
        <div class="card-title">
          Detalle <span class="separator">|</span> {{orderInfo.invoice_number}}
        </div>
        <div class="action-buttons-wrapper">
          <div class="action-button secondary-button" (click)="refundOrder()"
            *ngIf="orderInfo.status.short_name !=='refund' && !multiSelectMode">
            <fa-icon [icon]='faRotateLeft'></fa-icon>
            <p>Devolver pedido</p>
          </div>
          <div class="action-button  disabled-button" *ngIf="orderInfo.status.short_name ==='refund'">
            <fa-icon [icon]='faMoneyTransfer'></fa-icon>
            <p>Pedido devuelto </p>
          </div>
          <div class="action-button primary-button" (click)="printTicket('ticket_a4')"
            *ngIf="orderInfo.status.short_name !=='refund'">
            <fa-icon [icon]='faPrint'></fa-icon>
            <p>Imprimir entradas</p>
          </div>
          <div class="action-button primary-button" (click)="printTicket('ticket')"
            *ngIf="orderInfo.status.short_name !=='refund'">
            <fa-icon [icon]='faTicket'></fa-icon>
            <p>Imprimir ticket</p>
          </div>
        </div>
      </div>
      <div class="detail-card-content">
        <div class="order-meta-row">
          <div class="meta-item">
            <span class="meta-label">Nº pedido</span>
            <span class="meta-value">#{{ orderInfo.id_invoicing }}</span>
          </div>
          <div class="meta-divider"></div>
          <div class="meta-item">
            <span class="meta-label">Canal</span>
            <span class="meta-value">{{ getChannelName(orderInfo.id_channel) }}</span>
          </div>
          <div class="meta-divider"></div>
          <div class="meta-item">
            <span class="meta-label">Fecha</span>
            <span class="meta-value">{{ orderInfo.created_at | date: 'dd/MM/yyyy · HH:mm' }}</span>
          </div>
          <div class="meta-divider"></div>
          <div class="meta-item">
            <span class="meta-label">Total</span>
            <span class="meta-value meta-value--total">{{ orderInfo.total_order.total | number: '1.2-2' }}€</span>
          </div>
          <div class="meta-divider"></div>
          <div class="meta-item">
            <span class="meta-label">Estado</span>
            <div class="status-badge" [class]="orderInfo.status.short_name">
              <fa-icon [icon]='faCircle'></fa-icon>
              <span>{{ orderInfo.status.name }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="multi-select-section" *ngIf="allowMultiSelect()">
      <div class="select-many-wrapper" *ngIf="multiSelectMode==false" (click)="multiSelectMode=true">
        <fa-icon [icon]='faListRadio'></fa-icon>
        <p>Seleccionar varios</p>
      </div>
      <div class="multi-refund-wrapper" *ngIf="multiSelectMode==true">
        <div class="select-many-wrapper" (click)="multiSelectMode=false; multiSelectArray=[]">
          <fa-icon [icon]='faTimes'></fa-icon>
          <p>Cancelar</p>
        </div>
        <div class="action-button secondary-button" (click)="multiRefund()"
          [class.disabled]="multiSelectArray.length==0">
          <fa-icon [icon]='faRotateLeft'></fa-icon>
          <p>Devolver seleccionados</p>
        </div>
      </div>
    </div>
    <div class="event-card" *ngFor="let line of bookingsOrder">
      <div class="event-header">
        <div class="event-info-wrapper">
          <div class="event-img">
            <img [src]="urlImage + line.event.image_url" alt="">
          </div>
          <div class="event-info">
            <div class="info-row">
              <p class="title">{{line.event.title}}</p>
              <p class="subtitle">{{line.session.start_date | date: 'dd MMM': '+0000'}} | {{line.session.start_date |
                date: 'HH:mm': '+0000'}}h
              </p>
            </div>
            <div class="info-row">
              <p *ngIf="line.event.space" class="data">{{line.event.space.name}} - {{line.event.space.address}}</p>
              <p class="data">{{line.event.company.name}}</p>
            </div>
          </div>
        </div>
          <div>
            <div class="action-button secondary-button"
              *ngIf="!isAllEventRefund(line) && !multiSelectMode" (click)="refundEvent(line)">
              <fa-icon [icon]='faRotateLeft'></fa-icon>
              <p>Devolver las entradas de este evento</p>
            </div>
          </div>
      </div>
      <div class="ticket-row" *ngFor="let bookingTicket of line.bookings">
        <div class="info-wrapper">
          <mat-checkbox *ngIf="multiSelectMode && bookingTicket.booking.status.name!='refunded'"
            (change)="check($event.checked, bookingTicket)"></mat-checkbox>
          <ng-container *ngIf="bookingTicket.booking.status.name != 'refunded'">
            <fa-icon [icon]='faPrint' (click)="printSingleTicket(bookingTicket.booking.id, 'ticket_a4')"></fa-icon>
            <fa-icon [icon]='faTicket' (click)="printSingleTicket(bookingTicket.booking.id, 'ticket')"></fa-icon>
          </ng-container>
          <ng-container *ngIf="bookingTicket.booking.status.name == 'refunded'">
            <fa-icon class="icons-disabled" [icon]='faPrint'></fa-icon>
            <fa-icon class="icons-disabled" [icon]='faTicket'></fa-icon>
          </ng-container>
          <div class="ticket-info">
            <span class="ticket-name">{{bookingTicket.ticket.name}}</span>
            <span *ngIf="bookingTicket?.booking.seat" class="ticket-data">Zona:
              {{bookingTicket?.booking.seat.map_section.name}}, Fila:
              {{bookingTicket?.booking.seat.row}}, Asiento:
              {{bookingTicket?.booking.seat.seat}}</span>
          </div>
        </div>
        <div class="d-flex gap-3 align-items-center"
          *ngIf="bookingTicket.booking.status.name != 'refunded'">
          <div class="price-block">
            <ng-container *ngIf="bookingTicket.booking.discount_amount > 0; else noBookingDiscount">
              <span class="price price--original">{{ bookingTicket.booking.original_price | number:'1.2-2' }}€</span>
              <span class="price price--discounted">{{ (bookingTicket.booking.original_price - bookingTicket.booking.discount_amount) | number:'1.2-2' }}€</span>
            </ng-container>
            <ng-template #noBookingDiscount>
              <span class="price">{{ +bookingTicket.booking.price | number:'1.2-2' }}€</span>
            </ng-template>
          </div>
          <div class="refund-ticket-action" (click)="refundTicket(bookingTicket.booking.id)" *ngIf="!multiSelectMode">
            <span>Devolver entrada</span>
          </div>
        </div>
        <div class="refunded-ticket d-flex gap-3 align-items-center"
          *ngIf="bookingTicket.booking.status.name == 'refunded'">
          <span class="price text-decoration-line-through">{{+bookingTicket.booking.price | number:'1.2-2'}}€</span>
          <span>Devolución completada</span>
        </div>
      </div>
    </div>
    <div class="totals-card">
      <div class="totals-card-inner">

        <div class="totals-row">
          <span class="totals-label">Subtotal</span>
          <span class="totals-value">{{ orderInfo.total_order.subtotal_without_discount | number:'1.2-2' }} €</span>
        </div>

        <ng-container *ngIf="orderInfo.total_order.discount_total > 0">
          <div class="totals-row totals-row--discount totals-row--expandable"
               (click)="discountExpanded = !discountExpanded">
            <span class="totals-label">
              Descuentos
              <fa-icon [icon]="faChevronDown" class="totals-chevron" [class.rotated]="discountExpanded"></fa-icon>
            </span>
            <span class="totals-value">-{{ orderInfo.total_order.discount_total | number:'1.2-2' }} €</span>
          </div>
          <ng-container *ngIf="discountExpanded">
            <div class="totals-row totals-row--sub" *ngFor="let d of orderInfo.applied_discounts">
              <span class="totals-label">
                <fa-icon [icon]="d.promo_code ? faTag : faPercent"></fa-icon>
                {{ d.public_name }}
              </span>
              <span class="totals-value">-{{ d.discount_total | number:'1.2-2' }} €</span>
            </div>
          </ng-container>
        </ng-container>

        <div class="totals-row" *ngIf="orderInfo.total_order.fee_total > 0">
          <span class="totals-label">Comisión</span>
          <span class="totals-value">{{ orderInfo.total_order.fee_total | number:'1.2-2' }} €</span>
        </div>

        <div class="totals-row" *ngIf="orderInfo.total_order.refund_total > 0">
          <span class="totals-label">Devolución</span>
          <span class="totals-value">-{{ orderInfo.total_order.refund_total | number:'1.2-2' }} €</span>
        </div>

        <div class="totals-row totals-row--total">
          <span class="totals-label">Total</span>
          <span class="totals-value">{{ orderInfo.total_order.total | number:'1.2-2' }} €</span>
        </div>

      </div>
    </div>
  </div>
</div>